import { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faMinus } from '@fortawesome/free-solid-svg-icons';

import PageContext from '@contexts/PageContext';
import { Default, Mobile } from '@helpers/breakpoints';
import { getLanguageId } from '@helpers/language';
import { Container } from '@components';
import { checkEnabled, checkValue } from '@components/OptionalFeature';
import styles from './Downloads.module.scss';

const Downloads = ({ data, id, DarkMode, componentIsAvailable, showTitle }) => {
  const router = useRouter();
  const { locale } = router;
  const pageData = useContext(PageContext);

  /*Note: change true to false for checking component Dynamically*/
  const [showOnFrench, setShowOnFrench] = useState(true);

  useEffect(() => {
    //check componnet enabled in french /english
    const DisplayValue = data?.DisplayOptions?.find((x) => x.DisplayOptionKey == 'DisplayComponent').OptionInformation;
    if (DisplayValue === true) {
      if (locale == 'fr') {
        setShowOnFrench(true);
      } else {
        setShowOnFrench(true);
      }
    } else {
      if (locale == 'fr') {
        /*Note: change true to false for checking component Dynamically*/
        setShowOnFrench(true);
      } else {
        setShowOnFrench(true);
      }
    }
  }, []);


  // Brochure
  const brochureArr = pageData.ProductGallery.filter((item) => item.Id === 1)
    .shift()
    ?.GalleryItems?.map((gItem) => gItem.ProductGalleryContent)
    .filter((x) => parseInt(x.Language) === getLanguageId(locale) && x.Description);

  // Manual
  const manualArr = pageData.ProductGallery.filter((item) => item.Id === 2)
    .shift()
    ?.GalleryItems?.map((gItem) => gItem.ProductGalleryContent)
    .filter((x) => parseInt(x.Language) === getLanguageId(locale) && x.Description);

  // Catalogue
  const catalogueArr = pageData.ProductGallery.filter((item) => item.Id === 5)
    .shift()
    ?.GalleryItems?.map((gItem) => gItem.ProductGalleryContent)
    .filter((x) => parseInt(x.Language) === getLanguageId(locale) && x.Description);

  // check if DisplayBrochures enable
  const displayBrochures = checkEnabled(data?.DisplayOptions, 'DisplayBrochures');

  // check if DisplayManuals enable
  const displayManuals = checkEnabled(data?.DisplayOptions, 'DisplayManuals');

  // check if DisplayCatalogue enable
  const displayCatalogue = data?.DisplayOptions?.find(
    (x) => x.DisplayOptionKey == 'DisplayCatalogue' || x.DisplayOptionKey == 'DisplayCatalogues'
  )?.Enabled;

  // Manual Title Enabled
  const manualsTitleavailable = checkEnabled(data?.DisplayOptions, 'ManualsTitleText');

  // Manual Title
  const manualsTitle = checkValue(data?.DisplayOptions, 'ManualsTitleText', locale);

  // Brouchure Title available
  const broucherTitleAvailable = checkEnabled(data?.DisplayOptions, 'BrochuresTitleText');

  // The section title on the page
  const sectionTitle = checkValue(data?.DisplayOptions, 'ComponentHeaderTitleText', locale);

  // Brochure Title
  const brochureTitle = checkValue(data?.DisplayOptions, 'BrochuresTitleText', locale);

  // check Catalogue title Enabled
  const catalogueTitleAvailable = checkEnabled(data?.DisplayOptions, 'CatalogueTitleText');

  // Catalogue Title
  const catalogueTitle = checkValue(data?.DisplayOptions, 'CatalogueTitleText', locale);

  return (
    <section className={classNames(styles.Section, DarkMode ? styles.DarkMode : null)} id={id}>
      {componentIsAvailable && showOnFrench && (
        <Container className={styles.Container}>
          {showTitle && <h2 className={styles.Title}>{sectionTitle}</h2>}

          {displayBrochures && brochureArr?.length > 0 && (
            <dl className={classNames(styles.Downloads, DarkMode ? styles.DarkMode : null)}>
              <dt className={classNames(styles.Tab, DarkMode ? styles.DarkMode : null)}>
                {/* <FontAwesomeIcon icon={faMinus} /> */}
                {broucherTitleAvailable ? brochureTitle : null}
              </dt>
              <dt className={classNames(styles.Panel, DarkMode ? styles.DarkMode : null)}>
                <div className={styles.Column}>
                  <ul className={styles.List}>
                    {brochureArr.map((brochure, index) => (
                      <li key={index}>
                        <a className={styles.DownloadLink} href={brochure.FileNameUrl} download target="_blank" rel="noreferrer">
                          <span className={styles.ItemName}>{brochure.Description}</span>
                          <span className={styles.FileType}>{brochure.ContentType ? brochure.ContentType : 'PDF'}</span>
                          <span className={styles.DownloadPrompt}>
                            <Default>
                              {locale == 'en' ? 'Download' : 'Télécharger'}
                              <FontAwesomeIcon icon={faArrowDown} />
                            </Default>
                            <Mobile>{locale == 'en' ? 'Download' : 'Télécharger'}</Mobile>
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </dt>
            </dl>
          )}

          {displayCatalogue && catalogueArr?.length > 0 && (
            <dl className={classNames(styles.Downloads, DarkMode ? styles.DarkMode : null)}>
              <dt className={classNames(styles.Tab, DarkMode ? styles.DarkMode : null)}>
                {/* <FontAwesomeIcon icon={faMinus} /> */}
                {catalogueTitleAvailable ? catalogueTitle : null}
              </dt>
              <dt className={classNames(styles.Panel, DarkMode ? styles.DarkMode : null)}>
                <div className={styles.Column}>
                  <ul className={styles.List}>
                    {catalogueArr.map((cat, index) => (
                      <li key={index}>
                        <a className={styles.DownloadLink} href={cat.FileNameUrl} download>
                          <span className={styles.ItemName}>{cat.Description}</span>
                          <span className={styles.FileType}>{cat.ContentType ? cat.ContentType : 'PDF'}</span>
                          <span className={styles.DownloadPrompt}>
                            <Default>
                              {locale == 'en' ? 'Download' : 'Télécharger'}
                              <FontAwesomeIcon icon={faArrowDown} />
                            </Default>
                            <Mobile>{locale == 'en' ? 'Download' : 'Télécharger'}</Mobile>
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </dt>
            </dl>
          )}

          {displayManuals && manualArr?.length > 0 && (
            <dl className={classNames(styles.Downloads, DarkMode ? styles.DarkMode : null)}>
              <dt className={classNames(styles.Tab, DarkMode ? styles.DarkMode : null)}>
                {/* <FontAwesomeIcon icon={faMinus} /> */}
                {manualsTitleavailable ? manualsTitle : null}
              </dt>
              <dt className={classNames(styles.Panel, DarkMode ? styles.DarkMode : null)}>
                <div className={styles.Column}>
                  <ul className={styles.List}>
                    {manualArr.map((manual, index) => (
                      <li key={index}>
                        <a className={styles.DownloadLink} href={manual.FileNameUrl} download target="_blank" rel="noreferrer">
                          <span className={styles.ItemName}>{manual.Description}</span>
                          <span className={styles.FileType}>{manual.ContentType ? manual.ContentType : 'PDF'}</span>
                          <span className={styles.DownloadPrompt}>
                            <Default>
                              {locale == 'en' ? 'Download' : 'Télécharger'}
                              <FontAwesomeIcon icon={faArrowDown} />
                            </Default>
                            <Mobile>{locale == 'en' ? 'Download' : 'Télécharger'}</Mobile>
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </dt>
            </dl>
          )}
        </Container>
      )}
    </section>
  );
};

export default Downloads;
